import * as React from "react";
import { UitkLayoutFlex, UitkLayoutFlexItem } from "uitk-react-layout-flex";
import { UitkSpacing } from "uitk-react-spacing";
import { UitkText } from "uitk-react-text";

import EditorialBase from "../../EditorialBase";
import { ContentProps, EditorialFactoryProps } from "../../../typings";
import { decorateEditorialHtml } from "../../../ContentUtilities";

export class ConfidenceMessageImageEditorial extends EditorialBase {
  public constructor(editorial: EditorialFactoryProps) {
    super(editorial);
  }

  public generate(props: ContentProps) {
    const ICON_IMAGE_SIZE = 48;
    const { items } = this.editorial;
    const { media, text } = items[0];

    if (!media || media.length === 0 || !text) {
      return null;
    }

    return (
      <div
        id={this.id}
        data-fm={this.fmId}
        data-fm-title-id={this.fmTitleId}
        className="ConfidenceMessageImageEditorial"
        data-testid="confidence-message-image-editorial"
      >
        <UitkSpacing margin={{ block: "one" }}>
          <UitkLayoutFlex space="three" direction="row">
            <UitkLayoutFlexItem>
              <img src={media[0].mediaUrl} alt={media[0].mediaAlt} width={ICON_IMAGE_SIZE} height={ICON_IMAGE_SIZE} />
            </UitkLayoutFlexItem>
            <UitkLayoutFlexItem alignSelf="center" shrink={1}>
              <UitkText size={300}>
                <div dangerouslySetInnerHTML={decorateEditorialHtml(text)} />
              </UitkText>
            </UitkLayoutFlexItem>
          </UitkLayoutFlex>
        </UitkSpacing>
      </div>
    );
  }
}

export default ConfidenceMessageImageEditorial;
